import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {AuthProxy} from "../proxies/auth.proxy";

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private authProxy: AuthProxy = inject(AuthProxy);
  public isAuthenticated(): Observable<boolean> {
    return this.authProxy.isAuthenticated();
  }
}
